if (window.location.hostname == "localhost") {
  console.log("Skipping installation of Service Worker on localhost");
} else if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/green-mobility/sw.js")
      .then((registration) => {
        console.log("Service Worker registered: ", registration);
      }).catch((registrationError) => {
        console.error(
          "Service Worker registration failed: ",
          registrationError,
        );
      });
  });
} else {
  console.log("Service Worker not supported");
}
